import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CmsConfig, provideConfig, provideDefaultConfig, UrlModule} from '@spartacus/core';
import { CarouselModule, MediaModule } from '@spartacus/storefront';
import { UigProductReferencesComponent } from './uig-product-references.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductReferencesComponent: {
          component: UigProductReferencesComponent,
        },
      },
    }),
  ],
  declarations: [UigProductReferencesComponent],
  exports: [UigProductReferencesComponent],
})
export class UigProductReferencesModule {}
